const NAME = "THIRD_PARTY";

export default NAME;
